module.exports = __webpack_public_path__ + "static/media/Algemene-voorwaarden-voor-Kinderopvang-2017.7c4d6e5e.pdf";